import { Component, Fragment, h } from "preact";
import TransactionsHistoryPage from "../../desktop-components/user/menu-transaction-history";
import { Cell, CustomTable, FiltersRow, HCell, HRow, PaginationV2, PanelRow, Row, SelectFilter } from "../../utils/table-utils";
import { DateHelperFilter, PerPageFilter } from "../../utils/form-utils";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import * as U from "../../desktop-templates/menu-user";
import * as I from "../../utils/icons";
import MoneyFormatter from "../../utils/money-formatter";
import TicketLogic from "../../utils/ticket-logic";
import { Description } from "../../../../services/api/betting-api";

export class TransactionsHistoryMobile extends TransactionsHistoryPage {
    tableColumns() {
        return [
            <strong class="block text-center body-bg-color"><Trans>Data</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Descrizione</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Importo</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Saldo</Trans></strong>
        ];
    }

    tableDataMapper = (row) => {
        const label = !!row['is-sender'] ? 'new_sender_balance' : 'new_receiver_balance';
        const message = row.description.rawmessage || row.description.message;
        return [
            <span class="block text-center">
                {new Date(row.ts * 1000).toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })}
                &nbsp;
                {new Date(row.ts * 1000).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })}
            </span>,
            <span class="block text-left">
                {message
                    .replace(/(ticketid:.?)([a-f0-9]{20})/i, '$1<a>$2<a>')
                    .split('<a>')
                    .map(
                        (item, i) => i === 1
                            ? <a href="javascript:void(0);" class="text-blue-700 hover:text-blue-500 hover:underline" onClick={e => TicketLogic.printTicket({ id: item, code: item })}>{item}</a>
                            : <span>{item}</span>
                    )}
            </span>,
            <span class={'block text-right ' + (parseFloat(row.amount) < 0 ? 'text-red-600' : 'text-green-600')}>
                {row.wallet_type == "bonus" ? '🎁' : ''}
                <MoneyFormatter value={row.amount} currency={row.currency} />
            </span>,
            <span class="block text-right"><MoneyFormatter value={row[label]} currency={row.currency} /></span>
        ];
    }

    render({ TableFormatterExt = MobileTxnTable }) {
        return <div class="max-w-full overflow-x-hidden">
            <U.SubTabsContainer>
                <U.Tab selected={true}><Trans>Storico</Trans></U.Tab>
            </U.SubTabsContainer>
            <div class="user-menu-header main-text-color px-2 py-1 text-base font-bold ml-3 mt-2 capitalize rounded"><Trans>Storico Movimenti</Trans></div>
            <FiltersRow class="gap-2 grid grid-cols-2 [grid-template-areas:'h_h'_'s_e'_'p_c'] p-2 text-sm justify-center items-stretch">
                <label class="mx-px col-span-2">
                    <span class="block text-xs"><Trans>Servizio</Trans></span>
                    <SelectFilter class="bg-white py-2 w-full" onChange={e => {
                        this.state.reasonFilter = e.target.value;
                        this.setState(this.state);
                    }}>
                        <option value=""><Trans>Select type</Trans></option>
                        <option value="deposits"><Trans>Deposit</Trans></option>
                        <option value="withdraws"><Trans>Withdraw</Trans></option>
                        <option value="voucher"><Trans>Vouchers</Trans></option>
                        <option value="B"><Trans>Sport bet</Trans></option>
                        <option value="W"><Trans>Sport win</Trans></option>
                        <option value="casino-bet"><Trans>Casino bet</Trans></option>
                        <option value="casino-win"><Trans>Casino win</Trans></option>
                    </SelectFilter>
                </label>
                <DateHelperFilter
                    firstChild="col-span-2"
                    {...this.state.dateFilter}
                    onInput={(dateFilter) => {
                        this.state.dateFilter = dateFilter;
                        this.setState(this.state);
                    }}
                />
                <PerPageFilter
                    perPage={this.state.perPage}
                    pageList={[10, 20, 30, 50, 100]}
                    onInput={({ perPage }) => {
                        this.state.perPage = perPage;
                        this.setState(this.state);
                    }}
                />
                <div class="pt-4">
                    <a class="px-4 py-2 w-full flex items-center justify-center gap-2 sm:ml-5 bg-amber-400 text-black rounded" onClick={e => this.performSearch()}>
                        <Trans>Avvia Ricerca</Trans> <I.SearchIcon class="h-3 inline-block" />
                    </a>
                </div>
            </FiltersRow>
            <div class="text-sm mt-3">
                {this.state.response && this.state.response.totals && <div class="w-full flex justify-center p-2">
                    <div class="flex rounded w-full border border-slate-300 justify-around py-2">
                        <div class="flex flex-col items-center"><div><Trans>Tot in</Trans></div><div class="text-base"><MoneyFormatter value={this.state.response.totals.in} /></div></div>
                        <div class="flex flex-col items-center"><div><Trans>Tot out</Trans></div><div class="text-base"><MoneyFormatter value={this.state.response.totals.out} /></div></div>
                        <div class="flex flex-col items-center"><div><Trans>Total</Trans></div><div class="text-base"><MoneyFormatter value={this.state.response.totals.tot} /></div></div>
                    </div>
                </div>}
                <PaginatedList
                    page={this.state.response.page}
                    maxRows={this.state.response.totalrecords}
                    perPage={this.state.response.recordperpage}
                    onNavigation={(nextPage, nextLowLimit) => this.changePage(nextPage)}>
                    <table class="w-full max-w-screen border border-black">
                        <thead>
                            <tr class="bg-amber-400 text-slate-950 border-amber-700">
                                <th class="border border-inherit w-1/5"><Trans>Data</Trans></th>
                                <th class="border border-inherit "><Trans>Descrizione</Trans></th>
                                <th class="border border-inherit w-1/5"><Trans>Importo</Trans></th>
                                <th class="border border-inherit w-1/5"><Trans>Saldo</Trans></th>
                            </tr>
                        </thead>
                        {!!this.state.response.data.length && this.state.response.data.map(row => {
                            const label = !!row['is-sender'] ? 'new_sender_balance' : 'new_receiver_balance';

                            return <tr>
                                <td class="border border-inherit text-center text-wrap">
                                    <span class="text-wrap">
                                        {new Date(row.ts * 1000).toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: '2-digit' })}
                                        {' '}
                                        {new Date(row.ts * 1000).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })}
                                    </span>
                                </td>
                                <td class="border border-inherit text-center text-wrap break-all">
                                    <span class="text-xs text-wrap">
                                        {row.description.message
                                            ? <Description type={row.description.message} data={row.description.data} raw={row.description.rawmessage} />
                                            : row.description.rawmessage}
                                    </span>
                                </td>
                                <td class={"border border-inherit text-center text-wrap wrap-break-word " + (row.amount < 0 ? 'text-red-600' : 'text-green-600')}>
                                    {row.wallet_type == "bonus" ? '🎁' : ''}
                                    <MoneyFormatter value={row.amount} currency={row.currency} allow-break={true} />
                                </td>
                                <td class="border border-inherit text-center text-wrap wrap-break-word"><MoneyFormatter value={row[label]} currency={row.currency} allow-break={true} /></td>
                            </tr>
                        })}
                    </table>
                </PaginatedList>
            </div>
        </div>;
    }
}

function PaginatedList({ children, page, maxRows, perPage, onNavigation }) {
    const pages = Math.ceil(maxRows / perPage);
    return <div>
        {children}
        {!!page && !!pages && <PaginationV2
            pages={pages}
            currentPage={page}
            onNavigation={(page) => { onNavigation(page, (page - 1) * perPage) }}
            isLastPage={pages === page}
            pagechunks={1}
            pagecenterchunk={3}
        />}
    </div>
}

function MobileTxnTable({
    // Dati
    totalrecords = 0,
    recordperpage = 0,
    page = 0,
    lowlimit = 0,
    data = [],

    columns = [],
    colGroupMapper = false,

    style = "",
    rowClass = '',
    cellClass = '',
    noFirstCell = false,
    //> Callback che si aspetta in output un singolo array con cui formattare le varie celle di ogni riga
    rowDataMapper = null,
    //> Callback che si aspetta in output un array di array, perchè per ogni iterazione ha la possibilità di creare nuove righe
    rowsDataMapper = null,
    onNavigation = () => { },
    ...props
}) {
    const TotalNumberOfPages = Math.ceil(totalrecords / recordperpage);
    const _rowDataMapper = rowDataMapper === null && rowsDataMapper === null ?
        item => item : (rowDataMapper === null ? null : rowDataMapper);

    return <Fragment>
        <div>
            {!data.length ?
                <div class="text-center text-lg opacity-50">
                    <Trans>Non ci sono record da mostrare</Trans>
                </div>
                : <table style={style} class={props['class']}>
                    {colGroupMapper !== false && <colgroup>{colGroupMapper}</colgroup>}
                    {columns.length ? <thead>
                        <HRow class="text-center">
                            {columns.map((col, i) => <HCell class="font-bold bg-gray-200" first={i === 0}>{col}</HCell>)}
                        </HRow>
                    </thead> : null}
                    <tbody class="text-center">
                        {!!rowDataMapper && data.map((row, j) => _rowDataMapper(row, j)).map(
                            cells => <Row class={rowClass}>
                                {cells.map((item, i) => <Cell first={!noFirstCell && i === 0} class={!!cellClass ? cellClass : "p-1"} borderColor="var(--main-color)">
                                    {!Array.isArray(item) ? item : item.filter(subitem => subitem !== null).map(subitem => <div>{subitem}</div>)}
                                </Cell>)}
                            </Row>
                        )}
                        {!!rowsDataMapper && data.flatMap((row, j) => rowsDataMapper(row, j)).map(
                            cells => <Row class={rowClass}>
                                {cells.map((item, i) => <Cell first={!noFirstCell && i === 0} colspan={cells.length === 1 ? columns.length : 1} class={!!cellClass ? cellClass : (cells.length === 1 ? 'p-0' : 'p-1')} borderColor="var(--main-color)">
                                    {!Array.isArray(item) ? item : item.filter(subitem => subitem !== null).map(subitem => <div>{subitem}</div>)}
                                </Cell>)}
                            </Row>
                        )}
                    </tbody>
                </table>}
        </div>
        {onNavigation !== false && !!data.length && <PaginationV2
            pages={TotalNumberOfPages}
            currentPage={page}
            onNavigation={(page) => { onNavigation(page, page * recordperpage - recordperpage) }}
            isLastPage={TotalNumberOfPages === page}
        />}
    </Fragment>;
}
